export default __webpack_public_path__ + "static/media/package_grutto_nl.7fe9121b.jpg";